#import ~/graphql/fragments/Components/CraftLink.graphql

query Footer($site: [String!]! ) {
  footer: entry(section: "footer", site: $site) {
    ... on footer_Entry {
      menu: footerMenu {
        ... on footerMenu_link_BlockType {
          id
          link: menuLink {
            ... CraftLinkField
          }
        }
      }
      description: footerDescription
    }
  }
  contactInfo: entry(section: "generalInformation", site: $site) {
    ... on generalInformation_Entry {
      phoneNumber
      email
    }
  }
}
